import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { FilterModel } from '../../models/filters/filters.model';
import { SortModel } from '../../models/filters/sort.model';

@Injectable({
  providedIn: 'root',
})
export class ConsultationsService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  consultationList(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/PatientRecordCase?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters) {
      const resultFilter = filters.filter((x) => !!x.value);
      url += resultFilter.map((f) => `&${f.filterId}=${f.value}`).join('');
    }
    if (sort) {
      url += `&SortBy=${sort.column}&SortDescending=${
        sort.orderBy == 'descending'
      }`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  medicalInformations(): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetMedicalInformations`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  saveAndTakeImage(consultationData: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecord`,
      consultationData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  consultationDetailByPatientRecordCaseId(
    patientRecordCaseId: string
  ): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetConsultationDetail/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  patientRecordImagesByPatientId(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetPatientRecordCaseImages/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  patientRecordCaseReportsByPatientRecordCaseId(
    patientRecordCaseId: string
  ): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetPatientRapport/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  consultationTimeLineList(): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetConsultationTimeLineList`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  consultationTimeLineByCaseId(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/GetConsultationTimeLineByCaseId/GetPatientRapport/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  conclusionOptions(): Observable<any> {
    let url = `${environment.apiLocations.patient}/ConclusionOption`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  sendReport(reportData: any, patientRecordId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecordCase/CreateConsultationReport/${patientRecordId}`,
      reportData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  previewReport(reportData: any, patientRecordCaseId: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecordCase/SaveAndPreviewConsultationReport/${patientRecordCaseId}`,
      reportData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getReport(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetConsultationRapport/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  checkConsultationReport(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/CheckConsultationReport/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  createDIABPatientRecordCase(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecordCase/CreateDiabetesPatientRecordCase`,
      formData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  createSurveyForCaseDetail(id: string, formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecordCase/CreateSurveyForCaseDetail/${id}`,
      formData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  uploadEcgFile(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.patient}/PatientRecordCase/UploadEcgFile`,
      formData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getDiabetesPreparationPageInformations(): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/DiabetesPreparationPageInformations`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getPatientCaseCardInformation(patientId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/Patient/GetPatientCaseCardInformation/${patientId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getPatientRecordCaseDetail(caseId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecordCase/GetPatientRecordCaseDetail/${caseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
